
























































































































































import MbeSwitch from "@/components/shared/MbeSwitch.vue";
import { GdprAssociationsDef } from "@/model/component.model";
import { GdprSourceDto } from "@/model/data.model";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  ConsentSectionsBoolean,
  ConsentSectionsVersion
} from "./ConsentRenewalShowPage.vue";

@Component({
  components: {
    MbeSwitch
  }
})
export default class GdprSimple extends Vue {
  @Prop({ default: false })
  disableAllPermissions: boolean;

  @Prop({ required: true })
  gdprAssociations!: GdprAssociationsDef;

  @Prop({ required: true })
  originalGdprAssociations!: GdprAssociationsDef;

  @Prop({ required: true })
  gdprSourceToInjectOnDirty!: GdprSourceDto | null;

  @Prop({ required: true })
  hideConsentAgreement?: ConsentSectionsBoolean;

  @Prop({ required: true })
  latestPolicyVersion!: ConsentSectionsVersion;

  @Prop({ required: true })
  consentsConfirmation!: ConsentSectionsBoolean;

  @Prop({ required: true })
  countryLabel!: string;

  onSwitchClick(pressedSwitchName: keyof GdprAssociationsDef, value: boolean) {
    const modifiedGdprAssociations = { ...this.gdprAssociations };
    const pressedAssociation = modifiedGdprAssociations[pressedSwitchName];
    pressedAssociation.value = value ? 1 : 0;

    const isDirty =
      pressedAssociation.value !==
      this.originalGdprAssociations[pressedSwitchName].value;
    if (this.gdprSourceToInjectOnDirty) {
      const originalSource = this.originalGdprAssociations[pressedSwitchName]
        .source;
      /*pressedAssociation.source = isDirty
        ? { ...this.gdprSourceToInjectOnDirty }
        : { ...originalSource };*/
      pressedAssociation.source = { ...this.gdprSourceToInjectOnDirty };
    }
    this.$emit("modifiedGdprAssociations", modifiedGdprAssociations);
  }

  downloadPrivacyPolicy() {
    this.$emit("downloadPrivacyPolicy", this.latestPolicyVersion.vision);
  }

  onConsentAgreementChange(elementName: string, event: any) {
    const value = event.target.checked;
    const newConsentAgreement = {
      ...this.consentsConfirmation,
      [elementName]: value
    };
    this.$emit("confirmConsent", newConsentAgreement);
  }

  onDownloadPrivacyPolicy() {
    this.$emit("downloadPrivacyPolicy");
  }
}
